const styles = {
  section: {
    borderBottom: 'none'
  }
}

export default styles
